import { defineComponent as _defineComponent } from 'vue'
import { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import { useI18n } from '@/helpers/composables/useI18n';
import { computed } from 'vue';
import { PlanOffer } from '@/features/buybox/components/list/ListPromotionRow.vue';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { useExperiment } from '@/libraries/experiment';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionRowOfferLabelMBRExp',
  props: {
    title: null,
    promotionOffer: null,
    packagePlan: null,
    isHighlighted: { type: Boolean },
    localisedCountry: null
  },
  setup(__props: any) {

const props = __props as {
	title: TitleDetail;
	promotionOffer: TitleOfferFragment | null;
	packagePlan: PlanOffer | null;
	isHighlighted?: boolean;
	localisedCountry?: string | null;
};



const { t } = useI18n();
const { activeVariantWithControlGroup: buyRentExpVariant } = useExperiment('EXP_MERGE_BUY_RENT');

const retailPrice = computed(() => {
	if (props.packagePlan?.retailPrice) return t('WEBAPP_THEN_X_PER_MONTH', { price: props.packagePlan.retailPrice });
	return null;
});

const freeTrialText = computed(() => {
	// for providers which expect no packagePlan
	if (['jyn', 'jwt'].includes(props.promotionOffer?.package.shortName || '')) return t('WEBAPP_FREE');

	if (props.promotionOffer?.package.shortName === 'tbv') return t('WEBAPP_FREE_WITH_ADS');

	if (props.packagePlan?.durationDays) {
		return props.packagePlan.durationDays === 1
			? t('WEBAPP_1_DAY_FREE')
			: t('WEBAPP_X_DAYS_FREE', { days: props.packagePlan.durationDays });
	}
	return null;
});

const flagSrc = computed(() => {
	if (!props.localisedCountry) return undefined;
	const countryCode = props.localisedCountry === 'GB' ? 'UK' : props.localisedCountry;
	return `${JW_CONFIG.ASSETS_URL}/flags/${countryCode}.png`;
});

return { __sfc: true,props, t, buyRentExpVariant, retailPrice, freeTrialText, flagSrc }
}

})